import { useMemo } from 'react'

import { navSections, type PageRow } from '@/components/layout/nav-groups'
import SectionTabs from '@/components/layout/SectionTabs'
import type { StockTab } from '@/screens/stock/stockData'

/**
 * The stock's pages as the sidebar's own stock section lists them, all fourteen in one run — the
 * strip has no "Show more" — so the strip and the sidebar cannot list different pages.
 */
function stockPages(symbol: string, tab: StockTab): readonly PageRow[] {
  const section = navSections({ pathname: `/stocks/${symbol}`, search: { tab } }).find(
    (candidate) => candidate.id === 'stock',
  )
  return section?.kind === 'pages' ? [...section.pages.visible, ...section.pages.more] : []
}

/**
 * The stock page's own section tab strip, under the company head (pages revamp, 2026-10-27;
 * COMPARE-stock § How the stock section's tabs work): the shared strip, drawn inside the page at
 * every width rather than by the shell, which draws none for a page's own context section. The
 * sidebar's stock group stays too (owner D8). A pure function of the URL, so the pending page
 * draws the same strip the loaded page does.
 */
export default function StockSectionTabs({ symbol, tab }: { symbol: string; tab: StockTab }) {
  const tabs = useMemo(() => stockPages(symbol, tab), [symbol, tab])
  return <SectionTabs label={symbol} tabs={tabs} placement="inline" />
}
